<script setup lang="ts">
  import { computed, onMounted } from "vue";
  import Avatar from "~/components/Avatar.vue";
  import { useUserInfo } from "~/composables/useUserInfo";
  import { DATA_URL, DLS_URL, LOGIN_URL, REGISTER_URL } from "~/env";
  import { useMainStore } from "~/stores";

  const mainStore = useMainStore();
  const { getUserInfo } = useUserInfo();

  const isLogin = computed(() => mainStore.login);
  const avatar = computed(() => mainStore.avatar);
  const name = computed(() => mainStore.name);
  // const title = computed(() => mainStore.title);

  const onLogin = () => {
    location.replace(`${LOGIN_URL}&redirect=${encodeURIComponent(location.href)}`);
  };

  const onRegister = () => {
    location.replace(`${REGISTER_URL}&redirect=${encodeURIComponent(location.href)}`);
  };
  const onLogout = () => {
    mainStore.logout().then(() => {
      location.reload();
    });
  };

  onMounted(() => {
    getUserInfo();
  });
</script>

<template>
  <div ref="menu" class="info-menu">
    <div v-if="isLogin">
      <a-dropdown
        :trigger="['click']"
        overlay-class-name="avatar-dropdown"
        :get-popup-container="() => $refs.menu as HTMLElement"
        placement="bottom">
        <div class="avater-warp">
          <Avatar class="antd-pro-global-header-index-avatar" :src="avatar" :name="name" :size="36" />
          <icon-font type="zhankai" />
        </div>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a class="name">
                {{ name }}
              </a>
            </a-menu-item>
            <a-divider />
            <a-menu-item>
              <a :href="DATA_URL" target="_blank">得理法搜</a>
            </a-menu-item>
            <a-divider />
            <a-menu-item>
              <a :href="DLS_URL" target="_blank">得理律助</a>
            </a-menu-item>
            <a-divider />
            <a-divider />
            <a-menu-item>
              <a @click="onLogout">退出登录</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <div v-else class="login-wrap">
      <a class="login" @click="onLogin()">登录</a>
      <a class="register" @click="onRegister()">免费注册</a>
    </div>
  </div>
</template>

<style lang="less" scoped>
  :deep(.avatar-dropdown) {
    top: 60px !important;
    width: 210px;
    padding: 0;
    background: #fff;
    border-radius: 8px;

    .ant-dropdown-menu {
      padding-right: 24px;
      padding-left: 24px;

      .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
        height: 52px;
        padding: 0;
      }

      .ant-divider {
        background: #d9d9d9;
      }
    }

    a {
      display: inline-block;
      padding: 0;
      margin: 0;
      font-size: 14px;
      color: #666;
    }

    .name {
      max-width: 100%;
      overflow: hidden;
      font-size: 16px;
      font-weight: 600;
      color: #333;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ant-divider {
      margin: 0;
    }

    .ant-dropdown-menu-item:hover {
      background: transparent;
    }
  }

  .avater-warp {
    display: flex;
    align-items: center;
    cursor: pointer;

    .ant-avatar {
      width: 36px;
      height: 36px;
    }

    .anticon {
      margin-left: 4px;
      // width: 12px;
      // height: 12px;
      font-size: 12px;
    }
  }

  .login-wrap {
    display: flex;

    .login {
      width: 88px;
      height: 38px;
      margin-right: 16px;
      margin-left: 20px;
      font-size: 16px;
      font-weight: 500;
      line-height: 36px;
      color: #2f78ff;
      text-align: center;
      border: 1px solid #2f78ff;
      border-radius: 4px;
    }

    .register {
      width: 88px;
      height: 38px;
      font-size: 16px;
      font-weight: 500;
      line-height: 36px;
      color: #fff;
      text-align: center;
      background: #2f78ff;
      border-radius: 4px;
    }
  }
</style>
